import { Box, Container, Typography } from '@mui/material';
import * as Preact from 'preact';
import * as Button from './A_Button';
import * as OriginalPrice from './A_OriginalPrice';

export interface Props {
    price: number;
    originalPrice: number;
    onAddToBasket?: () => void;
}

export const Component = (p: Props) => {
    const showDiscount = p.originalPrice - p.price > 0;
    return (
        <>
            <Box
                boxSizing="border-box"
                width="100%"
                padding="24px"
                display="flex"
                flexDirection="column"
                gap="16px"
            >
                <Container
                    sx={{
                        padding: '0px !important',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography variant="body1" fontWeight="500">
                        Total Price:
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'end',
                            margin: '0px',
                            gap: '4px',
                        }}
                    >
                        {showDiscount && (
                            <OriginalPrice.Component originalPrice={p.originalPrice} />
                        )}
                        <Typography variant="body1" fontWeight="500">{`${Intl.NumberFormat(
                            'en-GB',
                            {
                                style: 'currency',
                                currency: 'GBP',
                            },
                        ).format(p.price)}`}</Typography>
                    </Box>
                </Container>
                {p.onAddToBasket && (
                    <Button.Component variant="contained" fullWidth onClick={p.onAddToBasket}>
                        Add to basket
                    </Button.Component>
                )}
            </Box>
        </>
    );
};

Component.displayName = 'BasketTotal';
